import React, { useState } from 'react'
import {
  Box,
  Button,
  Heading,
  Typography,
  Frame,
  TextField,
  SelectField
} from 'components'
import { ProgressBarFooter } from './FreelancerProgressBarFooter'
import firebase from 'utils/firebase'
import { ONBOARD_SKIP_VALIDATION } from '../../../constants'

const FreelancerPerformerAppearance = ({
  onboarding,
  user,
  stepIndex,
  totalSteps,
  onNext = () => {},
  onSubmit = () => {}
}) => {
  const [heightValue, setHeightValue] = useState(user?.heightValue || '')
  const [heightUnit, setHeightUnit] = useState(user?.heightUnit || 'Feet')
  const [heightInches, setHeightInches] = useState(user?.heightInches || '')
  const [weightValue, setWeightValue] = useState(user?.weightValue || '')
  const [weightUnit, setWeightUnit] = useState(user?.weightUnit || 'Pounds')
  const [hairColor, setHairColor] = useState(user?.hairColor || '')
  const [eyeColor, setEyeColor] = useState(user?.eyeColor || '')
  
  const handleSubmit = () => {
    // Validate that we have at least some appearance information
    if (heightValue || weightValue || hairColor || eyeColor) {
      // Save to user profile
      if (onboarding) {
        firebase.analytics().logEvent('user_performer_appearance_submit_click')
      }
      
      const data = {
        heightValue,
        heightUnit,
        ...(heightUnit === 'Feet' ? { heightInches } : {}),
        weightValue,
        weightUnit,
        hairColor,
        eyeColor
      }
      
      if (onSubmit) {
        onSubmit(data)
      }
      
      if (onNext) {
        onNext()
      }
    }
  }
  
  // Validation to enable Next button - at least one field should be filled, or skip validation if configured
  const isValid = ONBOARD_SKIP_VALIDATION || heightValue || weightValue || hairColor || eyeColor
  
  return (
    <Frame maxWidth="xs" user={user}>
      <Box mx="auto" maxWidth={430}>
        <Heading>
          Please give us details about your appearance.
        </Heading>
        
        {/* Height Row */}
        <Box my={3}>
          <Typography variant="h6" gutterBottom>
            Height
          </Typography>
          <Box display="flex" alignItems="center">
            <Box flexGrow={1} mr={2}>
              <TextField
                type="number"
                value={heightValue}
                onChange={(e) => setHeightValue(e.target.value)}
                min={0}
                style={{ width: '100%' }}
              />
            </Box>
            <Box minWidth={100}>
              <SelectField
                value={heightUnit}
                onChange={(e) => setHeightUnit(e.target.value)}
                choices={[
                  { value: 'Feet', label: 'Feet' },
                  { value: 'cm', label: 'cm' }
                ]}
              />
            </Box>
            {heightUnit === 'Feet' && (
              <Box ml={2} minWidth={100}>
                <TextField
                  label="Inches"
                  type="number"
                  value={heightInches}
                  onChange={(e) => setHeightInches(e.target.value)}
                  min={0}
                  max={11}
                  style={{ width: '100%' }}
                />
              </Box>
            )}
          </Box>
        </Box>
        
        {/* Weight Row */}
        <Box my={3}>
          <Typography variant="h6" gutterBottom>
            Weight
          </Typography>
          <Box display="flex" alignItems="center">
            <Box flexGrow={1} mr={2}>
              <TextField
                type="number"
                value={weightValue}
                onChange={(e) => setWeightValue(e.target.value)}
                min={0}
                style={{ width: '100%' }}
              />
            </Box>
            <Box minWidth={100}>
              <SelectField
                value={weightUnit}
                onChange={(e) => setWeightUnit(e.target.value)}
                choices={[
                  { value: 'Pounds', label: 'Pounds' },
                  { value: 'Kg', label: 'Kg' }
                ]}
              />
            </Box>
          </Box>
        </Box>
        
        {/* Hair Color Row */}
        <Box my={3}>
          <Typography variant="h6" gutterBottom>
            Hair Colour
          </Typography>
          <TextField
            value={hairColor}
            onChange={(e) => setHairColor(e.target.value)}
            style={{ width: '100%' }}
          />
        </Box>
        
        {/* Eye Color Row */}
        <Box my={3}>
          <Typography variant="h6" gutterBottom>
            Eye Colour
          </Typography>
          <TextField
            value={eyeColor}
            onChange={(e) => setEyeColor(e.target.value)}
            style={{ width: '100%' }}
          />
        </Box>
      </Box>
      
      {onboarding && (
        <ProgressBarFooter
          valid={isValid}
          stepIndex={stepIndex}
          firstStep={stepIndex}
          numSteps={totalSteps}
          onNext={handleSubmit}
          onPrev={() => {}}
          alwaysShowNav={ONBOARD_SKIP_VALIDATION}
        />
      )}
      
      {!onboarding && (
        <Box mx="auto" my={3} maxWidth={280}>
          <Button
            variant="contained"
            type="submit"
            style={{ width: '100%' }}
            onClick={handleSubmit}
            disabled={!isValid}
          >
            Next
          </Button>
        </Box>
      )}
    </Frame>
  )
}

export default FreelancerPerformerAppearance
